import React from 'react';
import TableHeader from '../../../components/TableHeader';
import { fixedFloatAndCommas } from '../../../utils/conversion';

const View = ({ data, company, config, queryParameters, activeView, onRowClick, activeAssets, activeLiabilities }) => {
  return (
    <div className='inner-view'>
      <div className='trial-view'>
        <div className='top-header'>
          <h3>{company.title}</h3>
          <span>
            <b>Balance Sheet</b> as of date <b>{queryParameters.singleDate}</b>
          </span>
        </div>
        <div className='mid-header'>
          <span>Assets</span>
          <span>Liability</span>
        </div>
        <div className='table-view'>
          <table>
            <TableHeader headerDetails={config.header} />
            {config.getAssetsBody({
              dataList: data.assetsLedgers,
              activeView,
              onRowClick,
              activeData: activeAssets,
              label: 'activeAssets',
            })}
          </table>
          <table>
            <TableHeader headerDetails={config.header} />
            {config.getLiabilityBody({
              dataList: data.liabilitiesLedgers,
              activeView,
              activeData: activeLiabilities,
              onRowClick,
              label: 'activeLiabilities',
            })}
          </table>
        </div>
        <div className='total'>
          <span className='left-align'>Total</span>
          <span className='right-align'>{fixedFloatAndCommas(data.totalBalance.assets)}</span>
          <span className='left-align'>Total</span>
          <span className='right-align'>{fixedFloatAndCommas(data.totalBalance.liabilities)}</span>
        </div>
      </div>
    </div>
  );
};

export default View;
